import { chooseSrcByWidth, parseSrcset } from 'shared/utils/imageUtils'
import { isSrcSetSupported } from 'views/utils/browserFeatureDetection'

import { BREAKPOINT_SMALL_TINY } from 'views/consts'

import { GALLERY_SELECTOR, ZOOMABLE_SELECTOR } from './MediaGallery/consts'

const SELECTOR_CONTAINER =
  '[data-clientside-hook~="imageGallery__zoom-container"]'
const ZOOM_ELEMENT_CLASS = 'o-ProductImageGallery__zoom'
const ZOOM_VISIBILITY_CLASS = 'is-visible'
const MEDIA_GALLERY_ZOOMABLE_IMAGE_SIZE = 1000
const SIZES_UPDATE_DELAY_MS = 250

export default () => {
  const galleries = [...document.querySelectorAll(GALLERY_SELECTOR)]
  const isSmall = window.matchMedia(BREAKPOINT_SMALL_TINY).matches

  galleries.forEach(galleryElement => {
    const zoomableImages = [
      ...galleryElement.querySelectorAll(ZOOMABLE_SELECTOR)
    ]
    const zoomImageContainer = document.querySelector(SELECTOR_CONTAINER)

    const initialiseZoom = () => {
      const zoomImageWrapper = document.createElement('div')
      let currentImageZoomed
      let currentImageElement
      let sizesUpdateTimeoutId

      const updateSizes = () => {
        const sizes = `${MEDIA_GALLERY_ZOOMABLE_IMAGE_SIZE}px`
        /** @type Array<HTMLSourceElement|HTMLImageElement> */
        const newPictureZoomedChildren = Array.from(
          currentImageZoomed.querySelectorAll('source, img')
        )
        newPictureZoomedChildren.forEach(element => {
          // eslint-disable-next-line no-param-reassign
          element.sizes = sizes

          if (!isSrcSetSupported()) {
            // Manually choose new `src` from `srcSet` for browsers that
            // do not support responsive images natively
            // eslint-disable-next-line no-param-reassign
            element.src = chooseSrcByWidth(
              parseSrcset(element.getAttribute('srcset')),
              MEDIA_GALLERY_ZOOMABLE_IMAGE_SIZE
            )
          }
        })
      }

      const showZoom = e => {
        const newImageElement = e.currentTarget
        if (currentImageElement !== newImageElement) {
          /** @type {HTMLPictureElement} */
          const newPicture = newImageElement.querySelector('picture')
          if (!newPicture) {
            return
          }

          const newPictureZoomed = newPicture.cloneNode(true)

          zoomImageWrapper.textContent = ''
          zoomImageWrapper.appendChild(newPictureZoomed)

          currentImageElement = newImageElement
          currentImageZoomed = newPictureZoomed

          // Initially we use original image for zoomed and change it to
          // high res after a delay for two reasons:
          // 1. saving a request on short hovers
          // 2. if we do it with small delay, browser will show original
          //    image and replace it with high quality one only after
          //    it’s downloaded
          setTimeout(updateSizes, SIZES_UPDATE_DELAY_MS)
        }
        zoomImageWrapper.classList.add(ZOOM_VISIBILITY_CLASS)
      }

      const hideZoom = () => {
        clearTimeout(sizesUpdateTimeoutId)
        zoomImageWrapper.classList.remove(ZOOM_VISIBILITY_CLASS)
      }

      const moveZoom = e => {
        requestAnimationFrame(() => {
          if (currentImageZoomed) {
            const boundingClientRect = e.target.getBoundingClientRect()
            const x = e.clientX - boundingClientRect.left
            const y = e.clientY - boundingClientRect.top
            const currentImageSizes =
              currentImageElement.getBoundingClientRect()
            const adjustedX =
              (currentImageZoomed.offsetWidth / currentImageSizes.width) * x
            const adjustedY =
              (currentImageZoomed.offsetHeight / currentImageSizes.height) * y
            const translateX = adjustedX - zoomImageWrapper.offsetWidth / 2
            const translateY = adjustedY - zoomImageWrapper.offsetHeight / 2

            currentImageZoomed.style.transform = `translate(${-translateX}px, ${-translateY}px)`
          }
        })
      }

      zoomImageWrapper.classList.add(ZOOM_ELEMENT_CLASS)
      zoomImageContainer.appendChild(zoomImageWrapper)

      zoomableImages.forEach(majorImage => {
        majorImage.addEventListener('mouseenter', showZoom, true)
        majorImage.addEventListener('mouseleave', hideZoom, true)
        majorImage.addEventListener('mousemove', moveZoom, true)
      })
    }

    if (zoomableImages.length && zoomImageContainer && !isSmall) {
      initialiseZoom()
    }
  })
}
